import { datadogRum, RumInitConfiguration } from "@datadog/browser-rum";

interface ExtendedRumInitConfiguration extends RumInitConfiguration {
  clientToken: string;
  service: string;
  sessionSampleRate: number;
  site: string;
  version: string;
}

export const useRumBrowser = () => {
  try {
    const environment = process.env.APP_ENV.toString().toLocaleLowerCase();

    if (!environment) {
      throw new Error("RUM isn't supported on this environment.");
    }

    const applicationId = process.env.RUM_APP_ID;
    const clientToken = process.env.RUM_CLIENT_TOKEN;

    if (!applicationId || !clientToken) {
      throw new Error("RUM application ID or client token is missing.");
    }

    const sessionEnvironmentSampleRates = {
      prod: 100,
      staging: 25,
      uat: 50
    };

    const config: ExtendedRumInitConfiguration = {
      applicationId,
      clientToken,
      defaultPrivacyLevel: "mask-user-input",
      env: process.env.APP_ENV,
      service: `omi-frontend-${process.env.APP_ENV.toLowerCase()}`,
      sessionSampleRate: sessionEnvironmentSampleRates[environment] ?? 0,
      site: "datadoghq.com",
      trackInteractions: true,
      useSecureSessionCookie: true,
      version: "1.0.1"
    };

    datadogRum.init(config);
    datadogRum.startSessionReplayRecording();
  } catch (error) {
    console.error(error);
  }
};
